import { render, staticRenderFns } from "./MenuMobile.vue?vue&type=template&id=f3f9656a&scoped=true&"
import script from "./MenuMobile.vue?vue&type=script&lang=js&"
export * from "./MenuMobile.vue?vue&type=script&lang=js&"
import style0 from "./MenuMobile.vue?vue&type=style&index=0&id=f3f9656a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f9656a",
  null
  
)

export default component.exports